import React from "react";
import { useTranslation } from "react-i18next";
import ShowContainer from "../../../mui/ShowContainer";

export default function BalanceStepper({ details, currency }) {
  const { t } = useTranslation();

  return (
    <div className="balance-breakdown__rows">
      {details.map((row, i) => (
        <div className="balance-breakdown__row" key={i}>
          <span className="balance-breakdown__row-index">{i + 1}</span>

          <div className="balance-breakdown__row-main">
            <div className="balance-breakdown__row-amount">
              {row.amount}
              <span className="balance-breakdown__row-currency">{currency}</span>
            </div>

            <div className="balance-breakdown__row-badges">
              <ShowContainer condition={row.wager}>
                <span className="balance-breakdown__badge">
                  {t("wager")} x{row.wager}
                </span>
              </ShowContainer>
              <ShowContainer condition={row.cashout}>
                <span className="balance-breakdown__badge">
                  {t("cashout")} x{row.cashout}
                </span>
              </ShowContainer>
            </div>
          </div>

          <div className="balance-breakdown__row-left">
            <span className="balance-breakdown__row-left-label">{t("left to wager")}</span>
            <span className="balance-breakdown__row-left-value">
              {row.remained} {currency}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
